/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useCallback } from 'react';
import { NAVIGATION_ITEM } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/action-subject-type.tsx';
import { FIXED_ITEM } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/component-type.tsx';
import { LEVEL_ONE } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/level.tsx';
import { MENU_ID_ANALYTIC_EVENT_IDS } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/side-nav.tsx';
import { MENU_ID_ASSETS } from '@jira/navigation-apps__sidebar-nav4-context/src/common/constants.tsx';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import type { AssetsAnalyticsItemId } from './types.tsx';

export const useAssetsUIAnalytics = (): {
	fireUINavigationItemAnalytics: (analyticsItemId: AssetsAnalyticsItemId) => void;
} => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const fireUINavigationItemAnalytics = useCallback(
		(analyticsItemId: AssetsAnalyticsItemId): void => {
			fireUIAnalytics(
				createAnalyticsEvent({
					action: 'clicked',
					actionSubject: NAVIGATION_ITEM,
				}),
				MENU_ID_ANALYTIC_EVENT_IDS[MENU_ID_ASSETS],
				{
					level: LEVEL_ONE,
					componentType: FIXED_ITEM,
					itemId: analyticsItemId,
				},
			);
		},
		[createAnalyticsEvent],
	);

	return {
		fireUINavigationItemAnalytics,
	};
};
